import { useMemo } from 'react';
import { isString, uniqueId } from 'lodash/fp';

export function useDefaultId(prefix: string, id?: string) {
    return useMemo(() => (isString(id) ? id : uniqueId(`${prefix}-`)), [prefix, id]);
}
